FREQUENCIES_EN = [
  { name: 'Weekly', frequency: 52 }
  { name: 'Every two weeks', frequency: 26 }
  { name: 'Twice a month', frequency: 24 }
  { name: 'Monthly', frequency: 12 }
  { name: 'Every two months', frequency: 6 }
  { name: 'Every three months', frequency: 4 }
  { name: 'Twice a year', frequency: 2 }
  { name: 'Yearly', frequency: 1 }
]

FREQUENCIES_FR = [
  { name: 'Hebdomadaire', frequency: 52 }
  { name: 'À la quinzaine', frequency: 26 }
  { name: 'Semi-mensuel', frequency: 24 }
  { name: 'Mensuel', frequency: 12 }
  { name: 'Bimensuellement', frequency: 6 }
  { name: 'Trimestriellement', frequency: 4 }
  { name: 'Semestriellement', frequency: 2 }
  { name: 'Annuellement', frequency: 1 }
]

angular.module('wbComponents').directive 'inputFrequencies', ['locale', (locale) ->
  restrict: 'A'
  scope: true
  link: ($scope, $el, $attrs) ->
    frequencies = if locale.isFrench() then FREQUENCIES_FR else FREQUENCIES_EN
    if $attrs.inputFrequencies isnt ''
      $scope.$watch $attrs.inputFrequencies, (values) ->
        $scope.frequencies = _.filter frequencies, (f) ->
          _.includes values, f.frequency
    else
      $scope.frequencies = frequencies
]
